import React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { fmtDateFr } from "@/components/placements/placementsShared";
import { useLang } from "@/i18n";

export default function ProgressionBar({ detail, onStageSelect }) {
  const { tf } = useLang();
  const milestones = detail.milestones || [];
  const isOpen = detail.status === "OPEN";

  const Circle = ({ m }) => {
    const base = "h-[22px] w-[22px] rounded-full shrink-0 transition-all";
    const visual = m.status === "completed"
      ? "bg-info text-white grid place-items-center"
      : m.status === "current"
        ? "border-2 border-info bg-info/10"
        : "border-2 border-border dark:border-white/[0.15] bg-card";
    if (!isOpen) {
      return (
        <span className={cn(base, visual)} data-testid={`milestone-${m.status === "completed" ? "done" : m.status}-${m.milestone_type}`}>
          {m.status === "completed" && <Check className="h-3 w-3" />}
        </span>
      );
    }
    return (
      <button
        type="button"
        onClick={() => onStageSelect?.(m.milestone_type)}
        title={tf("Modifier l'étape")}
        aria-label={`${tf("Modifier l'étape")} : ${tf(m.label)}`}
        className={cn(base, visual,
          "cursor-pointer hover:ring-4 hover:ring-info/15 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-info/30",
          m.status === "current" && "hover:bg-info/25")}
        data-testid={`milestone-${m.status === "completed" ? "done" : m.status}-${m.milestone_type}`}
      >
        {m.status === "completed" && <Check className="h-3 w-3" />}
      </button>
    );
  };

  return (
    <div className="mt-4 overflow-x-auto tabstrip-x pb-1" data-testid="discussion-progression">
      <ol className="flex items-start min-w-[560px]">
        {milestones.map((m, i) => (
          <li key={m.milestone_type} className="flex-1 min-w-0 relative">
            {i < milestones.length - 1 && (
              <span className={cn("absolute top-[11px] left-[calc(50%+14px)] right-[calc(-50%+14px)] h-px",
                m.status === "completed" ? "bg-info/60" : "bg-border dark:bg-white/[0.1]")} aria-hidden="true" />
            )}
            <div className="flex flex-col items-center text-center px-1">
              <Circle m={m} />
              <div className={cn("text-[11px] font-medium mt-1.5 leading-tight",
                m.status === "current" ? "text-info" : m.status === "completed" ? "text-foreground/80" : "text-muted-foreground/70")}>
                {tf(m.label)}
              </div>
              <div className="text-[10px] text-muted-foreground/70 mt-0.5">
                {m.completed_at ? fmtDateFr(m.completed_at)
                  : m.planned_at ? `${tf("Prévu le")} ${fmtDateFr(m.planned_at)}` : "\u00A0"}
              </div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
